import styled from 'styled-components';
import {
  PreviewMessageBox as PreviewMessageBoxStyled,
  PreviewMessageBoxFooter as PreviewMessageBoxFooterStyled,
  PreviewMessageBoxContent as PreviewMessageBoxContentStyled,
} from '../../styles';

export const PreviewMessageBox = styled(PreviewMessageBoxStyled)``;
export const PreviewMessageBoxFooter = styled(PreviewMessageBoxFooterStyled)``;

export const PreviewMessageBoxContent = styled(PreviewMessageBoxContentStyled)``;
